// Historico da ficha (auditoria.entity_history): quem mudou o que, com valor antes e depois.
import type { SpeciesProfileHistoryEntry } from "@/types/species-profile";
import { FIELD_LABELS } from "../profileFormat";
import { Section } from "./ProfileView";

const OPERATION: Record<string, { label: string; icon: string }> = {
  INSERT: { label: "Criou", icon: "ri-add-circle-line" },
  UPDATE: { label: "Alterou", icon: "ri-edit-line" },
  DELETE: { label: "Removeu", icon: "ri-delete-bin-line" },
  REVIEW: { label: "Revisou", icon: "ri-shield-check-line" },
};

function show(v: unknown): string {
  if (v === null || v === undefined || v === "") return "—";
  if (Array.isArray(v)) return v.length ? v.join(", ") : "—";
  if (typeof v === "boolean") return v ? "Sim" : "Não";
  const s = String(v);
  return s.length > 140 ? `${s.slice(0, 140)}…` : s;
}

export default function ProfileHistory({ entries }: { entries: SpeciesProfileHistoryEntry[] }) {
  return (
    <Section title="Histórico de alterações" icon="ri-history-line">
      {entries.length === 0 ? (
        <p className="text-sm text-foreground-400">
          Nenhuma alteração registrada. A ficha está como foi gerada.
        </p>
      ) : (
        <ol className="space-y-4">
          {entries.map((h) => {
            const op = OPERATION[h.operation] ?? { label: h.operation, icon: "ri-record-circle-line" };
            const what = h.entity_table === "species_pests"
              ? `praga/doença “${show((h.new_data ?? h.previous_data)?.common_name)}”`
              : "a ficha";
            const note = h.new_data?.note as string | undefined;
            const keys = Object.keys(h.new_data ?? h.previous_data ?? {}).filter(
              (k) => k !== "note" && !(h.entity_table === "species_profiles" && k === "review_status" && h.operation !== "REVIEW")
            );
            return (
              <li key={h.id} className="flex gap-3">
                <i className={`${op.icon} text-primary-600 mt-0.5`} />
                <div className="min-w-0 flex-1">
                  <p className="text-sm text-foreground-800">
                    <strong>{h.changed_by_name ?? "Usuário desconhecido"}</strong> {op.label.toLowerCase()} {what}
                    <span className="text-foreground-500"> · {new Date(h.changed_at).toLocaleString("pt-BR")}</span>
                  </p>
                  {note && <p className="text-xs text-foreground-600 mt-0.5">“{note}”</p>}
                  {h.operation === "UPDATE" && keys.length > 0 && (
                    <ul className="mt-1 space-y-0.5">
                      {keys.map((k) => (
                        <li key={k} className="text-xs text-foreground-600 break-words">
                          <span className="text-foreground-500">{FIELD_LABELS[k] ?? k}:</span>{" "}
                          <span className="line-through text-foreground-400">{show(h.previous_data?.[k])}</span>{" → "}
                          {show(h.new_data?.[k])}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </li>
            );
          })}
        </ol>
      )}
    </Section>
  );
}
